// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_widget_login_date_of_birth = /** @type {(inputs: {}) => string} */ () => {
	return `Date of Birth`
};

const de_widget_login_date_of_birth = /** @type {(inputs: {}) => string} */ () => {
	return `Geburtsdatum`
};

const es_widget_login_date_of_birth = /** @type {(inputs: {}) => string} */ () => {
	return `Fecha de Nacimiento`
};

const fr_widget_login_date_of_birth = /** @type {(inputs: {}) => string} */ () => {
	return `Date de Naissance`
};

const fi_widget_login_date_of_birth = /** @type {(inputs: {}) => string} */ () => {
	return `Syntymäaika`
};

const hi_widget_login_date_of_birth = /** @type {(inputs: {}) => string} */ () => {
	return `जन्म तिथि`
};

const ja_widget_login_date_of_birth = /** @type {(inputs: {}) => string} */ () => {
	return `生年月日`
};

const nl_widget_login_date_of_birth = /** @type {(inputs: {}) => string} */ () => {
	return `Geboortedatum`
};

const pt_widget_login_date_of_birth = /** @type {(inputs: {}) => string} */ () => {
	return `Data de Nascimento`
};

const ro_widget_login_date_of_birth = /** @type {(inputs: {}) => string} */ () => {
	return `Data Nașterii`
};

const th_widget_login_date_of_birth = /** @type {(inputs: {}) => string} */ () => {
	return `วันเกิด`
};

const ur_widget_login_date_of_birth = /** @type {(inputs: {}) => string} */ () => {
	return `تاریخ پیدائش`
};

const zh_hant1_widget_login_date_of_birth = /** @type {(inputs: {}) => string} */ () => {
	return `出生日期`
};

const da_widget_login_date_of_birth = /** @type {(inputs: {}) => string} */ () => {
	return `Fødselsdato`
};

const it_widget_login_date_of_birth = /** @type {(inputs: {}) => string} */ () => {
	return `Data di Nascita`
};

const vn_widget_login_date_of_birth = /** @type {(inputs: {}) => string} */ () => {
	return `Ngày Sinh`
};

const ko_widget_login_date_of_birth = /** @type {(inputs: {}) => string} */ () => {
	return `생년월일`
};

const tr_widget_login_date_of_birth = /** @type {(inputs: {}) => string} */ () => {
	return `Doğum Tarihi`
};

const lv_widget_login_date_of_birth = /** @type {(inputs: {}) => string} */ () => {
	return `Dzimšanas datums`
};

const ar_widget_login_date_of_birth = /** @type {(inputs: {}) => string} */ () => {
	return `تاريخ الميلاد`
};

const bs_widget_login_date_of_birth = /** @type {(inputs: {}) => string} */ () => {
	return `Datum rođenja`
};

const sl_widget_login_date_of_birth = /** @type {(inputs: {}) => string} */ () => {
	return `Datum rojstva`
};

const id_widget_login_date_of_birth = /** @type {(inputs: {}) => string} */ () => {
	return `Tanggal Lahir`
};

const sv_widget_login_date_of_birth = /** @type {(inputs: {}) => string} */ () => {
	return `Födelsedatum`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "fi" | "hi" | "ja" | "nl" | "pt" | "ro" | "th" | "ur" | "zh-Hant" | "da" | "it" | "vn" | "ko" | "tr" | "lv" | "ar" | "bs" | "sl" | "id" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const widget_login_date_of_birth = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.widget_login_date_of_birth(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("widget_login_date_of_birth", locale)
	if (locale === "en") return en_widget_login_date_of_birth(inputs)
	if (locale === "de") return de_widget_login_date_of_birth(inputs)
	if (locale === "es") return es_widget_login_date_of_birth(inputs)
	if (locale === "fr") return fr_widget_login_date_of_birth(inputs)
	if (locale === "fi") return fi_widget_login_date_of_birth(inputs)
	if (locale === "hi") return hi_widget_login_date_of_birth(inputs)
	if (locale === "ja") return ja_widget_login_date_of_birth(inputs)
	if (locale === "nl") return nl_widget_login_date_of_birth(inputs)
	if (locale === "pt") return pt_widget_login_date_of_birth(inputs)
	if (locale === "ro") return ro_widget_login_date_of_birth(inputs)
	if (locale === "th") return th_widget_login_date_of_birth(inputs)
	if (locale === "ur") return ur_widget_login_date_of_birth(inputs)
	if (locale === "zh-Hant") return zh_hant1_widget_login_date_of_birth(inputs)
	if (locale === "da") return da_widget_login_date_of_birth(inputs)
	if (locale === "it") return it_widget_login_date_of_birth(inputs)
	if (locale === "vn") return vn_widget_login_date_of_birth(inputs)
	if (locale === "ko") return ko_widget_login_date_of_birth(inputs)
	if (locale === "tr") return tr_widget_login_date_of_birth(inputs)
	if (locale === "lv") return lv_widget_login_date_of_birth(inputs)
	if (locale === "ar") return ar_widget_login_date_of_birth(inputs)
	if (locale === "bs") return bs_widget_login_date_of_birth(inputs)
	if (locale === "sl") return sl_widget_login_date_of_birth(inputs)
	if (locale === "id") return id_widget_login_date_of_birth(inputs)
	if (locale === "sv") return sv_widget_login_date_of_birth(inputs)
	return "widget_login_date_of_birth"
};